import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    void i18n.changeLanguage(lng);
  };

  const isEnglish = (i18n.language || '').startsWith('en');
  const isChinese = (i18n.language || '').startsWith('zh');

  return (
    <div className={`lang-switcher ${className}`.trim()}>
      <button
        type="button"
        onClick={() => changeLanguage('en')}
        style={{
          background: 'none',
          border: 'none',
          color: isEnglish ? '#007bff' : '#666',
          cursor: 'pointer',
          fontWeight: isEnglish ? 'bold' : 'normal',
          fontSize: '14px',
          padding: '0 2px',
        }}
      >
        EN
      </button>
      <span style={{ color: '#ccc' }}>|</span>
      <button
        type="button"
        onClick={() => changeLanguage('zh')}
        style={{
          background: 'none',
          border: 'none',
          color: isChinese ? '#007bff' : '#666',
          cursor: 'pointer',
          fontWeight: isChinese ? 'bold' : 'normal',
          fontSize: '14px',
          padding: '0 2px',
        }}
      >
        中文
      </button>
    </div>
  );
};

export default LanguageSwitcher;
